var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-slide-y-transition',[(_vm.show)?_c('v-system-bar',{attrs:{"height":"30","color":"primary"}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }